import * as React from "react";
import {
  Stack,
  Select,
  MenuItem as SelectMenuItem,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";

export function BrokerLandlordsForm({
  newLandlord,
  brokerCommissionRate,
  handleChange,
  handleCommissionRateChange,
  landlords,
  isLoadingLandlords,
  selectedLandlordMaxRate,
}) {
  return (
    <Stack spacing={2}>
      {isLoadingLandlords ? (
        <Typography variant="body2">Loading landlords…</Typography>
      ) : (
        <>
          <FormControl fullWidth>
            <InputLabel id="related-landlord-label">Select Landlord</InputLabel>
            <Select
              labelId="related-landlord-label"
              id="related-landlord"
              name="related_landlord"
              value={newLandlord || ""}
              onChange={handleChange}
              label="Select Landlord"
            >
              {landlords.map((landlord) => (
                <SelectMenuItem key={landlord.id} value={landlord.id}>
                  {landlord.business_name ||
                    `${landlord.related_user?.first_name || ""} ${landlord.related_user?.last_name || ""}`.trim() ||
                    `Landlord #${landlord.id}`}
                </SelectMenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            type="number"
            label="Broker commission rate (%)"
            value={brokerCommissionRate}
            onChange={handleCommissionRateChange}
            inputProps={{ min: 0, step: 0.1 }}
            required
            helperText={
              selectedLandlordMaxRate != null
                ? `Must be ≤ landlord max pay percentage (${selectedLandlordMaxRate}%).`
                : "Required on assign. Rate must not exceed landlord max pay percentage."
            }
          />
        </>
      )}
    </Stack>
  );
}
